<template>
    <div class="container-fluid">
        <!-- NAGŁÓWEK WIDOKU -->
        <div class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3 mb-4 px-3 px-md-0">
            <div>
                <h3 class="fw-bold mb-1">Ustawienia konta</h3>
                <p class="text-muted small mb-0">Zarządzanie powiązanymi kontami, danymi bilingowymi oraz bezpieczeństwem</p>
            </div>
        </div>

        <!-- PASEK ZAKŁADEK -->
        <ul class="nav nav-tabs custom-tabs mb-4 border-bottom" id="accountSettingsTab" role="tablist">
            <li class="nav-item" role="presentation">
                <button
                    class="nav-link d-flex align-items-center gap-2"
                    :class="{ active: activeTab === 'linked_accounts' }"
                    @click="activeTab = 'linked_accounts'"
                    type="button">
                    <i class="bi bi-people"></i>
                    <span>Powiązanie kont użytkowników</span>
                </button>
            </li>
            <li class="nav-item" role="presentation">
                <button
                    class="nav-link d-flex align-items-center gap-2"
                    :class="{ active: activeTab === 'invoice_data' }"
                    @click="activeTab = 'invoice_data'"
                    type="button">
                    <i class="bi bi-receipt"></i>
                    <span>Moje dane do faktury</span>
                </button>
            </li>
            <li class="nav-item" role="presentation">
                <button
                    class="nav-link d-flex align-items-center gap-2"
                    :class="{ active: activeTab === 'password_change' }"
                    @click="activeTab = 'password_change'"
                    type="button">
                    <i class="bi bi-key"></i>
                    <span>Zmiana hasła</span>
                </button>
            </li>
            <li class="nav-item" role="presentation">
                <button
                    class="nav-link d-flex align-items-center gap-2"
                    :class="{ active: activeTab === 'export_configs' }"
                    @click="activeTab = 'export_configs'"
                    type="button">
                    <i class="bi bi-share"></i>
                    <span>Konfiguracja eksportów</span>
                </button>
            </li>
        </ul>

        <!-- KARTA Z TREŚCIĄ ZAKŁADEK -->
        <div class="card border-0 shadow-sm">
            <div class="card-body p-4">
                <form v-if="activeTab !== 'export_configs'" @submit.prevent="saveSettings">
                    <LinkedAccountsTab v-if="activeTab === 'linked_accounts'" v-model="settings" />
                    <InvoiceDataTab v-if="activeTab === 'invoice_data'" v-model="settings" />
                    <PasswordChangeTab v-if="activeTab === 'password_change'" v-model="settings" />
                </form>
                <ExportConfigsTab v-if="activeTab === 'export_configs'" />
            </div>
        </div>
    </div>

    <!-- LOADER -->
    <div id="glownyloader">
        <AppLoader :show="loading || saving" :text="loaderText" />
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import AppLoader from '@/components/AppLoader.vue'

// Importy komponentów zakładek konta
import LinkedAccountsTab from '@/views/account-settings/LinkedAccountsTab.vue'
import InvoiceDataTab from '@/views/account-settings/InvoiceDataTab.vue'
import PasswordChangeTab from '@/views/account-settings/PasswordChangeTab.vue'
import ExportConfigsTab from '@/views/account-settings/ExportConfigsTab.vue'

const activeTab = ref('linked_accounts')
const loading = ref(false)
const saving = ref(false)
const loaderText = ref('')

const settings = ref({
    // Powiązane konta
    linkedUsers: [],

    // Dane do faktury
    invoiceData: {
        companyName: '',
        nip: '',
        street: '',
        buildingNumber: '',
        flatNumber: '',
        zipCode: '',
        city: '',
        country: 'PL'
    },

    // Zmiana hasła
    passwordForm: {
        currentPassword: '',
        newPassword: '',
        newPasswordConfirmation: ''
    }
})

const loadSettings = async () => {
    // Ładowanie ustawień konta z API
}

const saveSettings = async () => {
    // Zapisywanie ustawień konta do API
}

onMounted(() => {
    loadSettings()
})
</script>

<style scoped>
.custom-tabs .nav-link {
    color: var(--nav-link-color);
    font-weight: 500;
    border: none;
    border-bottom: 2px solid transparent;
    padding: 0.75rem 1.25rem;
    transition: all 0.2s ease;
}

.custom-tabs .nav-link:hover {
    color: var(--nav-link-hover-color);
    border-color: var(--nav-link-hover-border-color);
}

.custom-tabs .nav-link.active {
    color: var(--nav-link-active-color);
    border-bottom: 2px solid var(--nav-link-active-border-color);
    background-color: transparent;
    font-weight: 600;
}

.custom-tabs {
  display: flex !important;
  flex-wrap: nowrap !important; /* Blokuje łamanie do nowej linii */
  overflow-x: auto !important;   /* Włącza poziomy scroll */
  overflow-y: hidden;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch; /* Płynne przewijanie na iOS */
  scrollbar-width: thin; /* Cienki scrollbar dla Firefox */
}

/* Stylizacja paska przewijania zakładek */
.custom-tabs::-webkit-scrollbar {
  height: 4px;
}

.custom-tabs::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
}

.custom-tabs .nav-item {
  flex: 0 0 auto; /* Zapobiega ściskaniu pojedynczych zakładek */
}
</style>